import { ReactNode } from 'react'

export enum ExternalNameEnum {
  STEAM = 'Steam',
  GOOGLE = 'Google',
  APPLE = 'Apple',
  FACEBOOK = 'Facebook',
  DISCORD = 'Discord',
  TELEGRAM = 'Telegram'
}

export enum ExternalName {
  STEAM = 'steam',
  GOOGLE = 'google',
  APPLE = 'apple',
  FACEBOOK = 'facebook',
  DISCORD = 'discord',
  TELEGRAM = 'telegram'
}

export interface ConnectorExternal {
  title: string
  icon: ReactNode
  connectorId: ExternalName
}
